import React from 'react'
import _ from 'lodash'
import { FadeLoader } from 'react-spinners'
import InfiniteScroll from 'react-infinite-scroller'
import ProductBox from './ProductBox'
import * as StyledComponent from '../styles'

const ProductSearchResultList = (props, context) => {
  const { title, skus_pagination } = props
  const { is_last_page } = skus_pagination

  return <StyledComponent.ProductSearchResultList>
    {
      !_.isEmpty(title) && title.split('|').map((word, index) => <div key={word} className='product-group-title'>
        { word }
      </div>)
    }
    <InfiniteScroll
      className='products-infinite-scroll'
      pageStart={0}
      loadMore={props.loadMore}
      loader={<FadeLoader color={'#a3a3a3'} key={0} css={{ margin: 'auto' }} />}
      hasMore={!is_last_page}
      useWindow={false}
    >
      {
        props.skus.map((sku, index) => {
          return <ProductBox
            key={`product-box-${sku.id}-${index}`}
            product_sku={sku}
            add_to_bag_loading={props.add_to_bag_loading}
            add_to_bag_loading_id={props.add_to_bag_loading_id}
            onAddToBag={props.onAddToBag}
          />
        })
      }
    </InfiniteScroll>
  </StyledComponent.ProductSearchResultList>
}

export default ProductSearchResultList



// WEBPACK FOOTER //
// ./src/components/ProductSearchResultList.js